import Menu from '@/core/components/menu/menu';
import Toolbar from '@/core/components/toolbar/toolbar';
import { useCompanyWhenLoadPage } from '@/modules/company/hooks/useCompanyWhenLoadPage';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Loader } from 'vkit/lib/components';
import { Layout } from 'vkit/lib/modules';
import app from '@/../package.json';

const Application: React.FC = () => {
  const { loading } = useCompanyWhenLoadPage();

  const footer = {
    description: {
      portal: 'Portal do RH',
      general: `${new Date().getFullYear()} © Vitta Coordenação em Saúde`,
      version: `v${app.version}`,
    },
  };

  const getMenu = (isOpen: boolean) => <Menu isOpen={isOpen} />;

  return (
    <Layout header={<Toolbar />} asideFooter={footer} asideContent={getMenu}>
      {
        loading && (
          <Loader full color='colorDefault' />
        )
      }
      <Outlet />
    </Layout>
  );
};

export default Application;
